import axios from 'axios'
import { useEffect } from 'react'

const isPerimeterexError = error => {
  if (!error || typeof error !== 'object' || typeof error === 'undefined') {
    return false
  }

  const axiosError = error
  const statusCode = axiosError.response?.status

  if (statusCode !== 403) {
    return false
  }

  const headers = axiosError.response?.headers || {}
  const data = axiosError.response?.data

  const hasPxHeaders = Object.keys(headers).some(
    key =>
      key.toLowerCase().startsWith('px-') ||
      key.toLowerCase().includes('perimeterx')
  )

  const hasPxBody =
    data && typeof data === 'object' && ('appId' in data || 'uuid' in data)

  return hasPxHeaders || !!hasPxBody
}

const handleRequest = async () => {
  await axios.get('/api/filter/car/LocationSearch')
}

export default function Perimeterex() {
  const handleInitialRequest = async () => {
    try {
      await handleRequest()
    } catch (error) {
      if (isPerimeterexError(error)) {
        const wasRefreshed =
          sessionStorage?.getItem('perimeterx_refreshed') === 'true'

        if (isPerimeterexError(error) && !wasRefreshed) {
          sessionStorage?.setItem('perimeterx_refreshed', 'true')

          window.location.reload()
        }
      }
    }
  }

  useEffect(() => {
    handleInitialRequest()
  }, [])

  return null;
}
